export enum InvoiceStatus {
    inProcessing = "In Processing",
    processed = "Processed",
    combined = "Combined"
}
